import React, { useState } from "react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import FileSaver from "file-saver";
import SideBar from "../components/SideBar";
import LiveCode from "../components/liveCode";

import disney from "../assets/img/Disney.png";
import context from "../assets/img/context.png";
import redux from "../assets/img/redux.png";
import dashboard from "../assets/img/DashboardHome.jpg";

import CodeEditor from "../components/codeEditor";
import Counter, {
  counterCode,
  counterCss,
} from "../components/subComponent/counter";
import TodoApp, {
  TodoAppCode,
  TodoAppCss,
} from "../components/subComponent/todoApp";
import Calculator, {
  calculatorCode,
  calculatorCss,
} from "../components/subComponent/Calculator";

export const BASE_URL = "https://www.youtube.com/";
export const CLOUD_URL = "https://res.cloudinary.com/osperb/video/upload";

function ReactCourse() {
  const initialState = {
    counter: "demo",
    todo: "demo",
    calculator: "demo",
    disney: "demo",
    dashboard: "pdf",
  };

  const [state, setState] = useState(initialState);

  const year = new Date().getFullYear();

  function download(FileUrl) {
    FileSaver.saveAs(`${FileUrl}`, "CMS_Design.pdf");
  }

  return (
    <div className="App">
      <header className="App-header">
        <h2>Welcome to React Course</h2>
      </header>
      <Row className="w-100 m-0">
        <Col className="col-lg-9 col-12 px-5">
          {/* what is react  */}
          <p id="whatIsReact" className="mb-4 pb-4"></p>
          <Row className="mt-5">
            <Col lg={12} className="mt-3 mb-3 text-start">
              <h3>What is React ?</h3>
              <ul>
                <li>
                  React is a JavaScript library - one of the most popular ones
                </li>
                <li>
                  React is not a framework (unlike Angular, which is more
                  opinionated).
                </li>
                <li>React is an open-source project created by Facebook.</li>
                <li>
                  React is used to build user interfaces (UI) on the front end.
                </li>
                <li>
                  JSX, and it is a syntax extension to JavaScript. We recommend
                  using it with React to describe what the UI should look like.
                  JSX may remind you of a template language, but it comes with
                  the full power of JavaScript.
                </li>
              </ul>
              <p>
                One of the most important aspects of React is the fact that you
                can create components, which are like custom, reusable HTML
                elements, to quickly and efficiently build user interfaces.
                React also streamlines how data is stored and handled, using
                state and props.
              </p>
            </Col>

            <hr />
          </Row>
          {/* Get Started */}
          <p id="getStarted" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="">Get Started</h3>
              <ul>
                <li>
                  Basic familiarity with{" "}
                  <span className="marked">HTML & CSS</span>.
                </li>
                <li>Basic knowledge of JavaScript and programming.</li>
                <li>
                  Basic understanding of the <span className="marked">DOM</span>
                  .
                </li>
                <li>
                  Familiarity with <span className="marked">ES6</span> syntax
                  and features.
                </li>
                <li>
                  <span className="marked">Node.js</span> and{" "}
                  <span className="marked">npm</span> installed globally.
                </li>
              </ul>
            </Col>
            <Col className="mt-3" lg={8}>
              <Card className="bg-dark ">
                <CardBody className="code-screen text-start">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://nodejs.org/en/download/"
                    className="text-warning"
                  >
                    Install Node.js
                  </a>
                  <br />
                  <span className="text-white">
                    <span className="redMark">npm install latest-version</span>{" "}
                    # To install locally,
                    <br />{" "}
                    <span className="redMark">
                      npm install -g latest-version
                    </span>{" "}
                    # To install globally
                  </span>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* JSX */}
          <p id="jsx" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="">Introducing JSX</h3>
              <ul>
                <li>syntax is neither a string nor HTML 👉🏻</li>
                <li>Basic knowledge of JavaScript and programming.</li>
                <li>
                  We recommend using it with React to describe what the UI
                  should look like
                </li>
                <li>JSX may remind you of a template language,</li>
                <li>but it comes with the full power of JavaScript.</li>
              </ul>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              <CodeEditor code={`const element = <h1>Hello, world!</h1>`} />

              <p className="text-start pt-2">
                👉🏻 In the example below, we declare a variable called name and
                then use it inside JSX by wrapping it in curly braces:
              </p>

              <CodeEditor
                code={`const name = 'Josh Perez';
const element = <h1>Hello, {name}</h1>`}
              />

              <p className="text-start pt-2">
                <span className="redMark">!!</span> You can put any valid{" "}
                <span className="marked">JavaScript expression</span> inside the
                curly <span className="marked">braces</span> in JSX
              </p>
            </Col>
          </Row>
          {/* Rendering */}
          <p id="rendering" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="">Rendering</h3>
              <ul>
                <li>
                  Applications built with just React usually have a single root
                  DOM node
                </li>
                <li>
                  React renders HTML to the web page by using a function called
                  <span className="marked">render()</span>.
                </li>
                <li>
                  The purpose of the function is to display the specified HTML
                  code inside the specified HTML element.
                </li>
                <li>
                  In the ender() method, we can read props and state and return
                  our JSX code to the root component of our app
                </li>
              </ul>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              <p className="text-start pt-2">
                There is a {`<div>`} somewhere in your HTML file:
              </p>
              <CodeEditor code={`<div id="root"></div>`} />
              <p className="text-start pt-2">
                We call this a “root” DOM node because everything inside it will
                be managed by React DOM.
              </p>
              <p className="text-start pt-2">
                <span className="redMark">!!</span> The DOM (Document Object
                Model) represents the web page as a tree structure. Any piece of
                HTML that we write is added as a node, to this tree. With
                JavaScript, we can access any of these nodes (HTML elements) and
                update their styles, attributes, and so on
              </p>

              <p className="text-start pt-2">
                To render a React element, first pass the DOM element to
                ReactDOM.createRoot(), then pass the React element to
                root.render():
              </p>
              <CodeEditor
                code={`const root = ReactDOM.createRoot(
document.getElementById('root')
);\n
const element = <h1>Hello, world</h1>;
root.render(element);`}
              />
            </Col>
          </Row>
          {/* //Let's Create a App */}
          <p id="createApp" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="">Let's Create a App </h3>
              <ul>
                <li>Open Terminal. </li>
                <li>
                  <span className="marked">
                    npx create-react-app (app-name){" "}
                  </span>
                </li>
                <li>
                  after installation use this command (code .) to open vs-code.
                </li>

                <li>your root index.js file look like this 👉🏻</li>
                <li style={{ cursor: "pointer" }}>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.youtube.com/watch?v=9hb_0TZ_MVI&list=PLC3y8-rFHvwgg3vaYJgHGnModB54rxOk3&index=2"
                  >
                    Learn more
                  </a>
                </li>
              </ul>
            </Col>
            <Col className="mt-3" lg={8}>
              <Card className="bg-dark ">
                <CardBody
                  className="code-screen text-start "
                  style={{ height: "400px", padding: "0" }}
                >
                  <video
                    height={"100%"}
                    width={"100%"}
                    controls
                    src={`${CLOUD_URL}/v1661931186/React%20doc/ReactJS_Tutorial_-_2_-_Hello_World_zqet3f.mp4`}
                  ></video>
                </CardBody>
              </Card>
              <p className="text-start mt-4">React JS Folder Structure </p>
              <Card>
                <CardBody
                  className="code-screen text-start "
                  style={{ height: "400px", padding: "0" }}
                >
                  <video
                    height={"100%"}
                    width={"100%"}
                    controls
                    src={`${CLOUD_URL}/v1661931199/React%20doc/ReactJS_Tutorial_-_3_-_Folder_Structure_r0zwjp.mp4`}
                  ></video>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* A Simple Component */}
          <p id="aComponent" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="">A Simple Component</h3>
              <ul className="mb-5 pb-5">
                <li>
                  Functional component is just a simple javascript function{" "}
                </li>
                <li>
                  {" "}
                  it accepts the data in the form of props and returns the react
                  element
                </li>
              </ul>
              <ul className="pt-2">
                <li>
                  React is pretty flexible but it has a single strict rule:
                </li>
                <li className="mt-2">
                  <span className="marked " style={{ fontWeight: "bold" }}>
                    All React components must act like pure functions with
                    respect to their props.
                  </span>
                </li>
              </ul>
            </Col>
            <Col className="mt-3" lg={8}>
              <Card>
                <LiveCode
                  code={`function HelloMessage(){\nreturn "Hellow World"\n}`}
                />
                <LiveCode
                  code={`Hellow = () => {\nreturn "Hellow - arrow funtion"\n}`}
                />
              </Card>

              <p className="text-start pt-2">👉🏻 Consider this sum function:</p>

              <CodeEditor code={`function sum(a, b) {\n    return a + b;\n}`} />
              <p className="text-start pt-2">
                Such functions are called <span className="marked">“pure”</span>{" "}
                because they do not attempt to change their inputs, and always
                return the same result for the same inputs.
              </p>

              <p className="text-start pt-2">
                👉🏻 In contrast, this function is impure because it changes its
                own input:
              </p>

              <CodeEditor
                code={`function withdraw(account, amount) {\n    account.total -= amount;\n}`}
              />
            </Col>
          </Row>
          {/* Component props */}
          <p id="props" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="">Component props</h3>
              <ul>
                <li>
                  This function is a valid React component because it accepts a
                  single “props” (which stands for properties) object argument
                  with data and returns a React element
                </li>
              </ul>
            </Col>
            <Col className="mt-3" lg={8}>
              <Card>
                <LiveCode
                  noInline
                  code={`const Parent = ({prop}) => (\n<h3>\n{prop}\n</h3>\n)\nrender(<Parent prop={'Hellow World'}/>\n)`}
                />
              </Card>
            </Col>
          </Row>
          {/* Indroducing React-router-dom */}
          <p id="howToAddAPage" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="">How To add a Page in React</h3>
              <ul>
                <li className="marked">npm install react react-dom</li>
                <li>
                  We use <span className="marked">react-router-dom</span> for
                  create multi page application{" "}
                </li>
                <li>
                  React Router DOM is an npm package that enables you to
                  implement dynamic routing in a web app
                </li>
                <li>
                  It allows you to display pages and allow users to navigate
                  them.
                </li>
                <li>
                  {" "}
                  It is a fully-featured client and server-side routing library
                  for React
                </li>
                <li>
                  Route is the conditionally shown component that renders some
                  UI when its path matches the current URL.
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.youtube.com/watch?v=UjHT_NKR_gU&t=185s"
                  >
                    Learn More
                  </a>
                </li>
              </ul>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              <CodeEditor
                code={`import { BrowserRouter as Router, Routes, Route } from "react-router-dom";\n\nfunction App() {\n     return (\n        <Router>\n            <Routes>\n                <Route path="/home" element={<Home />} />\n                <Route path="/page2" element={<Page2 />} />\n            </Routes>\n        </Router>\n);\n}`}
              />
              <p className="text-start pt-2">This is the syntax of Router,</p>
              <Card>
                <CardBody
                  className="code-screen text-start "
                  style={{ height: "400px", padding: "0" }}
                >
                  <video
                    height={"100%"}
                    width={"100%"}
                    controls
                    src={`${CLOUD_URL}/v1661933715/React%20doc/React_Router_V6_Tutorial_-_Routes_Redirecting_UseNavigate_UseParams..._cljp7h.mp4`}
                  ></video>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* how to make 404 page */}
          <p id="howToMake404" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="">How To Make a 404 page</h3>
              <ul>
                <li>What happen when user go to URL that does not exist ?</li>
                <li>we can handle this with add a 404 route</li>
                <li>for example 👉🏻</li>
              </ul>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              <CodeEditor
                code={`import { BrowserRouter as Router, Routes, Route } from "react-router-dom";\n     function App() {\n        return (\n           <Router>\n             <Routes>\n               <Route path="/home" element={<Home />} />\n                <Route path="/page2" element={<Page2 />} />\n               <Route path="*" element={<NotFound />} />\n             </Routes>\n           </Router>\n  );\n}`}
              />
              <p className="text-start pt-2">
                This{" "}
                <span className="redMark">{`<Route path="*" element={<NotFound />} />`}</span>{" "}
                handles nonexistent routes in a special way. The{" "}
                <span className="redMark">asterisk ('*')</span> at the path prop
                causes the route to be called when a nonexistent path is hit. It
                then displays the <span className="redMark">"NotFound"</span>{" "}
                component.
              </p>
              <p className="text-start pt-2">
                displays the NotFound component when no other routes match the
                requested path.
              </p>
              <p className="text-start pt-2">
                It is purposely set at the bottom of the Route so it will be the
                last to be matched, you must make it the last route
              </p>
            </Col>
          </Row>
          {/* navigate between pages */}
          <p id="howToNavigate" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="">How To Navigate Between Pages</h3>
              <ul>
                <li>
                  We use <span className="marked">react-router-dom</span> for
                  the navigation{" "}
                </li>
                <li>
                  We can use <span className="marked">{`<Link />`}</span> for
                  the navigation
                </li>
                <li>
                  the tag has a prop <span className="marked">'to'</span>, that
                  is for what route you want to navigate to
                </li>
                <li>you can use Link any inside a BrowserRouter</li>
              </ul>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              <CodeEditor
                code={`import { Link } from "react-router-dom";\nfunction Page2() {\n        return (\n          <div>\n            <Link to="/home"> Go to Home Page </Link>\n          </div>\n  );\n}`}
              />

              <p className="text-start pt-2">
                <span className="redMark">!!</span> Can we Navigate when user
                click a button with onCLick function ?
              </p>
              <p>
                Yes we can use <span className="marked">'useNavigate'</span> to
                do that
              </p>
              <CodeEditor
                code={`import { useNavigate } from "react-router-dom";\n\nconst navigate = useNavigate()\n\nconst handleNavigation = () => {\n  navigate("/home");\n};\nfunction Page2() {\n    return (\n      <div>\n        <button onClick={handleNavigation} > Go to Home Page </button>\n      </div>\n  );\n}`}
              />
            </Col>
          </Row>

          {/*hooks*/}
          <p id="commonlyUsedReactHooks" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="">Commonly Used React Hooks</h3>
              <ul>
                <li>How to Save and update data with react ?</li>
                <h4>useState</h4>
                <li>
                  We can use <span className="marked">useState</span> to save
                  data in react
                </li>
                <li>
                  State can be updated in response to event handlers, server
                  responses, or prop changes.{" "}
                </li>
                <li> This is done using the setState() method.</li>
                <li>
                  The setState() method enqueues all of the updates made to the
                  component state and instructs React to re-render the component
                  and its children with the updated state
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.youtube.com/watch?v=LlvBzyy-558&t=2201s"
                  >
                    Learn more about React hooks
                  </a>
                </li>
              </ul>
            </Col>

            <Col className="mt-3 text-start" lg={8}>
              <CodeEditor
                code={`import { useState } from "react";\n\n\nfunction App() {\n   const [state, setState] = useState('initial data is added here');\n\n return <h1> {state} </h1>\n}`}
              />

              <p className="text-start pt-2">
                <span className="redMark">!!</span> The initial data is show in
                the screen
              </p>

              <p>
                <span className="redMark">?</span> How to change the initial
                value to my name
              </p>
              <CodeEditor
                code={`import { useState } from "react";\n\n\nfunction App() {\n   const [state, setState] = useState('initial data is added here');\n\n return (\n     <div>\n        <h1> {state} </h1>\n\n        <p>Change state value to your name</p>\n\n        <button onClick={()=>setState("your name")} >Change</button>\n     </div>\n)\n}`}
              />

              <p className="pt-1">
                <span className="redMark">!!</span> the state accepts all types
                (string,number,boolean,array,object...)
              </p>

              <p className="pt-1">
                <span className="redMark">👍</span>{" "}
                <span className="text-info">try your self</span> make a counter
                with useState
              </p>
              <div className="d-flex align-item-center justify-content-end">
                <p
                  className={
                    "w-fit px-4 demo-tag " +
                    `${state.counter === "demo" ? "active" : ""}`
                  }
                  onClick={() => setState({ ...state, counter: "demo" })}
                >
                  Demo
                </p>
                <p
                  className={
                    "w-fit px-4 demo-tag " +
                    `${state.counter === "jsx" ? "active" : ""}`
                  }
                  onClick={() => setState({ ...state, counter: "jsx" })}
                >
                  React JSX
                </p>
                <p
                  className={
                    "w-fit px-4 demo-tag " +
                    `${state.counter === "css" ? "active" : ""}`
                  }
                  onClick={() => setState({ ...state, counter: "css" })}
                >
                  css
                </p>
              </div>

              {state.counter === "demo" && <Counter />}
              {state.counter === "jsx" && <CodeEditor code={counterCode} />}
              {state.counter === "css" && <CodeEditor code={counterCss} />}
            </Col>
          </Row>
          <p id="useEffect" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <ul>
                <h4 id="">useEffect</h4>
                <li>
                  The useEffect Hook allows you to perform side effects in your
                  components.
                </li>
                <li>
                  Some examples of side effects are: fetching data, directly
                  updating the DOM, and timers.
                </li>
                <li>
                  useEffect accepts two arguments. The second argument is
                  optional.
                </li>
                <li>
                  {" "}
                  The first one is a callback (a function), and the second one
                  is the dependency array
                </li>
              </ul>
            </Col>

            <Col className="mt-3 text-start" lg={8}>
              <CodeEditor
                code={`useEffect(() => {\n   console.log("I run everytime this component rerenders")\n});`}
              />
              <p className="text-start pt-2">
                <span className="redMark">!!</span> This function run Every
                rerender
              </p>
              <CodeEditor
                code={`useEffect(() => {\n   console.log("I Only run once (When the app gets rendered)")\n}, []);`}
              />
              <p className="text-start pt-2">
                <span className="redMark">!!</span> This function Only run once
                when the app rendered
              </p>
              <p>
                <span className="redMark">{`[]`}</span> this represent the
                dependency array
              </p>
              <CodeEditor
                code={`useEffect(() => {\n  console.log("I run everytime my condition is changed")\n }, [condition]);`}
              />
              <p className="text-start pt-2">
                <span className="redMark">!!</span> This function run everytime
                the Condition change
              </p>
              <CodeEditor
                code={`useEffect(() => {\n  console.log("I run everytime my condition is changed")\n\n  return () => {\n    console.log("Use this return as a 'clean up tool' (this runs before the actual code)")\n  }\n}, [condition]);`}
              />
              <p className="text-start pt-2">
                <span className="redMark">!!</span> This function run everytime
                the Condition change
              </p>
              for Example :
              <CodeEditor
                code={`useEffect(() => {\n   // set our variable to true\n   let isApiSubscribed = true;\n   function((response) => {\n        if (isApiSubscribed) {\n             // handle success\n        }\n   });\n   return () => {\n        // cancel the subscription\n        isApiSubscribed = false;\n   };\n}, [condition]);`}
              />
            </Col>
          </Row>
          <p id="useNavigate" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <ul>
                <h4 id="">useHistory / useNavigate </h4>
                <li>
                  In react-router-dom version 6{" "}
                  <span className="marked">useHistory()</span> is replaced by
                  <span className="marked"> useNavigate()</span>
                </li>
                <li>
                  This is one of the most popular hooks provided by React Router
                </li>
                <li>
                  It lets you access the history instance used by React Router
                </li>

                <li>
                  Using the history instance you can redirect users to another
                  page
                </li>
                <li>This is the another way to Navigate Between Pages</li>
              </ul>
            </Col>

            <Col className="mt-3 text-start" lg={8}>
              <CodeEditor
                code={`import { useNavigate } from 'react-router-dom';\n\nfunction Page2() {\n\nconst navigate = useNavigate()\n\nconst handleNavigation = () => {\n   navigate('/home');\n};\nreturn (\n    <div>\n      <button onClick={handleNavigation}> Go to Home Page \n      </button>\n    </div>\n  );\n}
              `}
              />
              <p className="text-start pt-2">
                <span className="redMark">!!</span>You can{" "}
                <span className="marked">pass state</span> values through
                useNavigate()
              </p>
              for Example :
              <CodeEditor
                code={`import { useNavigate } from 'react-router-dom';\n\nfunction Page2() {\n\nconst navigate = useNavigate()\n\nconst handleNavigation = () => {\n   navigate('/home',{ state: { id: 1, count:'0' } });\n};\n\nreturn (\n    <div>\n      <button onClick={handleNavigation}> Go to Home Page \n      </button>\n    </div>\n  );\n}
              `}
              />
            </Col>
          </Row>
          <p id="useLocation" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <ul>
                <h4 id="">useLocation </h4>
                <li>
                  This hook returns the location object used by the
                  react-router.
                </li>
                <li>
                  Whenever the URL changes, the useLocation() hook returns a
                  newly updated location object
                </li>
              </ul>
            </Col>

            <Col className="mt-3 text-start" lg={8}>
              <p className="text-start pt-2">
                <span className="redMark">!!</span> You can get the state value
                from the Home component by useing{" "}
                <span className="marked">useLocation()</span>
              </p>
              <CodeEditor
                code={`import { useLocation } from "react-router-dom";\n\nfunction Home() {\n\nconst location = useLocation();\n\nconsol.log(location.state)\n\nreturn (\n      <div>\n          <h1>Home </h1>\n          <p>count : {location.state.count}</p>\n      </div>\n  )\n}
                `}
              />
              <p className="text-start pt-2">
                <span className="redMark">!!</span> You can also pass
                <span className="marked">'search', 'hash'</span> values through
                useNavigate()
              </p>
              <CodeEditor
                code={`navigate({\n    pathname: "/home",\n    search: '?search=count',\n    hash: "hashtag",\n});`}
              />
            </Col>
          </Row>

          <p id="useReducer" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="">useReducer</h3>
              <ul>
                <li>
                  {" "}
                  Here reducer is the user-defined function that pairs the
                  current state with the dispatch method to handle the state
                </li>
                <li>
                  {" "}
                  initialArgs refers to the initial arguments and init is the
                  function to initialize the state lazily
                </li>
                <li>
                  {" "}
                  <a
                    href="https://youtu.be/IHJ-TO_1nME"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    Learn More
                  </a>
                </li>
              </ul>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              Syntax :
              <CodeEditor
                code={`const [state, dispatch] = useReducer(reducer, initialArgs, init)`}
              />
              <CodeEditor
                code={`const initialState = {count: 0};

function reducer(state, action) {
  switch (action.type) {
    case 'increment':
      return {count: state.count + 1};
    case 'decrement':
      return {count: state.count - 1};
    default:
      throw new Error();
  }
}

function Counter() {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <>
      Count: {state.count}
      <button onClick={() => dispatch({type: 'decrement'})}>-</button>
      <button onClick={() => dispatch({type: 'increment'})}>+</button>
    </>
  );
}
`}
              />
              <p id="LearnMoreAboutReactHooks" className="mb-4 pb-4"></p>
              <p className="mt-4">Learn more about React hooks</p>
              <Card>
                <CardBody
                  className="code-screen text-start "
                  style={{ height: "400px", padding: "0" }}
                >
                  <video
                    height={"100%"}
                    width={"100%"}
                    controls
                    src={`${CLOUD_URL}/v1661935913/React%20doc/React_Hooks_Course_-_All_React_Hooks_Explained_1_hjwj93.mp4`}
                  ></video>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* 1st project */}
          <p id="ProjectOne" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="">Project one</h3>
              <ul>
                <li>
                  <h5>A TODO App</h5>
                </li>
                <li>We Learn</li>
                <ol>
                  <li>
                    how to use state effectively to save and update data.{" "}
                  </li>
                  <li>how to add an item to state</li>
                  <li>how to delete an item from state</li>
                  <li>how to update an item from state</li>
                  <li>how to render component conditionally</li>
                  <li>how to filter an item from state</li>
                  <li>how to list all items from state</li>
                </ol>
              </ul>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              <p className="text-start pt-2">
                <span className="redMark">!!</span> Let's do a project with what
                we have learned so far
              </p>
              <p id="todo">TODO App Demo 📝</p>
              <div className="d-flex align-item-center justify-content-end">
                <p
                  className={
                    "w-fit px-4 demo-tag " +
                    `${state.todo === "demo" ? "active" : ""}`
                  }
                  onClick={() => setState({ ...state, todo: "demo" })}
                >
                  Demo
                </p>
                <p
                  className={
                    "w-fit px-4 demo-tag " +
                    `${state.todo === "jsx" ? "active" : ""}`
                  }
                  onClick={() => setState({ ...state, todo: "jsx" })}
                >
                  React JSX
                </p>
                <p
                  className={
                    "w-fit px-4 demo-tag " +
                    `${state.todo === "css" ? "active" : ""}`
                  }
                  onClick={() => setState({ ...state, todo: "css" })}
                >
                  css
                </p>
              </div>
              {state.todo === "demo" && <TodoApp />}
              {state.todo === "jsx" && <CodeEditor code={TodoAppCode} />}
              {state.todo === "css" && <CodeEditor code={TodoAppCss} />}
            </Col>
          </Row>
          <p id="calculator" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <ul>
                <li>
                  <h5 id="">A Calculator</h5>
                </li>
              </ul>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              <p>Calculator Demo 📝</p>
              <div className="d-flex align-item-center justify-content-end">
                <p
                  className={
                    "w-fit px-4 demo-tag " +
                    `${state.calculator === "demo" ? "active" : ""}`
                  }
                  onClick={() => setState({ ...state, calculator: "demo" })}
                >
                  Demo
                </p>
                <p
                  className={
                    "w-fit px-4 demo-tag " +
                    `${state.calculator === "jsx" ? "active" : ""}`
                  }
                  onClick={() => setState({ ...state, calculator: "jsx" })}
                >
                  React JSX
                </p>
                <p
                  className={
                    "w-fit px-4 demo-tag " +
                    `${state.calculator === "css" ? "active" : ""}`
                  }
                  onClick={() => setState({ ...state, calculator: "css" })}
                >
                  css
                </p>
              </div>

              {state.calculator === "demo" && <Calculator />}
              {state.calculator === "jsx" && (
                <CodeEditor code={calculatorCode} />
              )}
              {state.calculator === "css" && (
                <CodeEditor code={calculatorCss} />
              )}
            </Col>
          </Row>
          <p id="disney" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <ul>
                <li>
                  <h5 id=""> Create a Disney+ clone</h5>
                </li>
              </ul>
            </Col>

            <Col className="mt-3 text-start" lg={8}>
              <div className="d-flex align-item-center justify-content-end">
                <p
                  className={
                    "w-fit px-4 demo-tag " +
                    `${state.disney === "demo" ? "active" : ""}`
                  }
                  onClick={() => setState({ ...state, disney: "demo" })}
                >
                  Create a UI Design
                </p>
                <p className={"w-fit px-4 demo-tag "}>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://github.com/osperb/React-project-2"
                  >
                    Download Design File
                  </a>
                </p>
                <p className={"w-fit px-4 demo-tag "}>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.youtube.com/watch?v=KPUEvRo5xtY&list=PL-J2q3Ga50oOqz_VQ12fG650FV4-sCm9W&index=1&t=157s"
                  >
                    Api Integration
                  </a>
                </p>
              </div>

              {state.disney === "demo" && (
                <Card className=" ">
                  <CardBody className="text-start ">
                    You can make this design by watching the tutorial&nbsp;
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.youtube.com/watch?v=kn8HPNwPEkw&list=PL-J2q3Ga50oOqz_VQ12fG650FV4-sCm9W&index=2"
                    >
                      Watch Now
                    </a>
                    <div className="mt-2">
                      <img
                        alt="react_doc"
                        height={"100%"}
                        width="100%"
                        src={disney}
                      />
                    </div>
                  </CardBody>
                </Card>
              )}
            </Col>
          </Row>

          {/* context api */}
          <p id="ContextApi" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="">Context Api</h3>
              <ul>
                <li>
                  In a typical React application, data is passed top-down
                  (parent to child) via props,
                </li>
                <li>
                  Context provides a way to share values like these between
                  components without having to explicitly pass a prop through
                  every level of the tree.
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.youtube.com/watch?v=sP7ANcTpJr8"
                  >
                    {" "}
                    Learn More
                  </a>
                </li>
              </ul>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              <Card className="mb-2">
                <CardBody className="text-start ">
                  <div className="mt-2">
                    <img
                      alt="react_doc"
                      height={"100%"}
                      width="100%"
                      src={context}
                    />
                  </div>
                </CardBody>
              </Card>
              Example :
              <CodeEditor
                code={`import React from 'react';
import PageContextProvider from './PageContextProvider';
import Home from './Home';

function App() {
    return (
        <div className="App">
            <PageContextProvider>
                <Home />
            </PageContextProvider>
        </div>
    );
}
export default App;`}
              />
              <p className="mb-0 pb-0 mt-2">PageContextProvider.js</p>
              <CodeEditor
                code={`import React, { useState, useEffect, createContext } from 'react';
export const PageContext = createContext();

const PageContextProvider = (props) => {

    const [user, setUser] = useState({
        'name': 'harry potter'
    });

    return (
        <PageContext.Provider value={{ 
            user: user,
        }}>
          {props.children}
        </PageContext.Provider>
    );
}
export default PageContextProvider;`}
              />
              <p className="mb-0 pb-0 mt-2">Home.js</p>
              <CodeEditor
                code={`import React, { useContext } from 'react';
import { PageContext } from './PageContextProvider';

const Header = () => {
    const { user } = useContext(PageContext);
    return (
        <div className="header">
          {user.name}
        </div>
    );
}
export default Header;`}
              />
            </Col>
          </Row>

          {/* redux */}
          <p id="redux" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="redux">Redux </h3>
              <ul>
                <li>
                  {" "}
                  Redux works with any UI layer, and has a large ecosystem of
                  addons to fit your needs.
                </li>
                <li>
                  {" "}
                  Redux helps you write applications that behave consistently,
                  run in different environments (client, server, and native),
                  and are easy to test.
                </li>
                <li>
                  Centralizing your application's state and logic enables
                  powerful capabilities like undo/redo, state persistence, and
                  much more.
                </li>
                <li>
                  The Redux DevTools make it easy to trace when, where, why, and
                  how your application's state changed. Redux's architecture
                  lets you log changes, use "time-travel debugging", and even
                  send complete error reports to a server.
                </li>
                <li>
                  {" "}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.youtube.com/watch?v=poQXNp9ItL4&t=78s"
                  >
                    {" "}
                    Learn More
                  </a>
                </li>
              </ul>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              <Card className="mb-2">
                <CardBody className="text-start">
                  <img
                    alt="react_doc"
                    height={"100%"}
                    width="100%"
                    src={redux}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* redux example */}
          <p id="reduxeg" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="reduxeg">Redux Basic Example </h3>
              <ul>
                <li>npm install redux react-redux </li>
                <li>npm i redux-thunk</li>
                <li>
                  Install Redux DevTools Extension{" "}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en"
                  >
                    Install Now
                  </a>
                </li>
                <li>create a Store folder in src</li>
                <li>create a store.js in store folder </li>
              </ul>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              <p className="mb-0 pb-0">store.js</p>
              <CodeEditor
                code={`import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import rootReducer from "./Reducer";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;  // connect your redux store to chrome Redux DevtoolS

const store = createStore(
rootReducer,
composeEnhancers(applyMiddleware(thunkMiddleware))
);
export default store;`}
              />

              <p className="mb-0 pb-0 pt-1">
                ⚫️ Import store in index.js file
              </p>
              <p className="mb-0 pb-0 pt-1">index.js</p>
              <CodeEditor
                code={`import { Provider } from "react-redux";
import store from "./Store/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <div>
        <App />
      </div>
    </Provider>
  </React.StrictMode>
);`}
              />

              <p className="mb-0 pb-0 pt-1">
                create rootReducer.js in store folder
              </p>
              <p className="mb-0 pb-0 pt-1">rootReducer.js</p>

              <CodeEditor
                code={`import { combineReducers } from "redux"
import LoginReducer from "./Login/Reudcer"
   
const rootReducer = combineReducers({
LoginReducer
})

export default rootReducer`}
              />
            </Col>
          </Row>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <p className="">
                Create a folder with the name of the API you are using, for
                example I am using Login API so I create a folder with the name
                Login
              </p>
              <p>The files contained in the folder</p>
              <ul>
                <li>actionType.js</li>
                <li>action.js</li>
                <li>reducer.js</li>
                <li>useApi.js</li>
              </ul>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              <p className="mb-0 pb-0 pt-1">actionType.js</p>
              <CodeEditor
                code={`export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";`}
              />

              <p className="mb-0 pb-0 pt-1">action.js</p>
              <CodeEditor
                code={`import { LOGIN_FAIL, LOGIN_REQUEST, LOGIN_SUCCESS } from "./actionType";
    
export const loginRequest = (input) =>
({
type: LOGIN_REQUEST,
payload: input,
});
            
export const loginSuccess = (userDetails) => ({
type: LOGIN_SUCCESS,
payload: userDetails,
});
            
export const loginFail = (error) => ({
type: LOGIN_FAIL,
payload: error,
});`}
              />

              <p className="mb-0 pb-0 pt-1">reducer.js</p>
              <CodeEditor
                code={`import { LOGIN_FAIL, LOGIN_REQUEST, LOGIN_SUCCESS } from "./actionType";
    
const initiailState = {
  loding: false,
  error: "",
  userDetails: [],
};


const LoginReducer = (state = initiailState, action) => {
switch (action.type) {
  case LOGIN_REQUEST:
    return {
      ...state,
      loding: true,
    };
            
  case LOGIN_SUCCESS:
    return {
      ...state,
      loding: false,
      userDetails: action.payload,
      error: "",
    };
  case LOGIN_FAIL:
    return {
      ...state,
      loding: false,
      error: action.payload,
    };
  default:
    return state;
}
};
            
export default LoginReducer;`}
              />

              <p className="mb-0 pb-0 pt-1">useApi.js</p>
              <CodeEditor
                code={`import { loginFail, loginRequest, loginSuccess } from "./action";

export const loginApi = (input) => { 
  return async (dispatch) => {
                
    dispatch(loginRequest(input));
                
    try {
      const res = await axios.post("YOUR_API",input);
      dispatch(loginSuccess(res));
    } catch (error) {
        dispatch(loginFail(error?.response?.data));
    }
  };
}`}
              />

              <p className="mb-0 pb-0 pt-1">
                To login the user, calls the login Api function in the login.js
                file
              </p>
              <p className="mb-0 pb-0 pt-1">Login.js</p>

              <CodeEditor
                code={`import { useDispatch, useSelector } from "react-redux";
    
function Login() {
    const dispatch = useDispatch();
            
    const { loginError, loading } = useSelector((state) => ({
        loginError: state.error,
        loading: state.loading,
    }));

    const handleSubmitLogin=(input)=>{
        dispatch(loginApi(input));  
    }


    return ( your component )

 }
            
 export default Login;`}
              />
            </Col>
          </Row>

          {/* final project */}
          <p id="finalProject" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="finalProject">
                Final Project - <br />
                Create a Dashboard
              </h3>
              <ul>
                <li>All the files you need are provided in Git Repository, </li>
                <li>Contact your supervisor to access the Git Repo</li>
              </ul>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              <div className="d-flex align-item-center justify-content-end">
                <p
                  className={
                    "w-fit px-4 demo-tag " +
                    `${state.dashboard === "pdf" ? "active" : ""}`
                  }
                  onClick={() => setState({ ...state, dashboard: "pdf" })}
                >
                  Design
                </p>
                <p
                  className={
                    "w-fit px-4 demo-tag " +
                    `${state.dashboard === "api" ? "active" : ""}`
                  }
                  onClick={() => setState({ ...state, dashboard: "api" })}
                >
                  Api Document
                </p>
              </div>
              {state.dashboard === "pdf" && (
                <Card className="mb-2">
                  <CardBody className="text-start ">
                    <div className="mt-2">
                      <img
                        alt="react_doc"
                        height={"100%"}
                        width="100%"
                        src={dashboard}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <Button
                        onClick={() =>
                          download(
                            "https://drive.google.com/file/d/1Tt4Mnj7hYssCoNfk8hGYwvCc6mI0SNe0/view?usp=sharing"
                          )
                        }
                        className="w-25 btn btn-success text-white btn-sm"
                      >
                        Download Full Design
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              )}
              {state.dashboard === "api" && <CodeEditor code={dashboardApi} />}
            </Col>
          </Row>

          {/* git */}
          <p id="git" className="mb-4 pb-4"></p>
          <Row className="mb-4 mt-4">
            <Col lg={4} className="mt-3 mb-3 text-start">
              <h3 id="git">Basic GIT Commands </h3>
            </Col>
            <Col className="mt-3 text-start" lg={8}>
              <CodeEditor code={gitCommand} />
            </Col>
          </Row>
        </Col>
        <Col
          className="col-3 d-none d-lg-block"
          style={{ background: "#e9ecef" }}
        >
          <SideBar />
        </Col>
      </Row>
      <footer style={{ marginTop: "10rem" }} className="mb-4">
        <p>
          Developed by&nbsp;
          <a
            target="_blank"
            rel="noreferrer"
            href="https://osperb.com"
            title="website development firm"
          >
            <span to="/">Osperb</span>,
          </a>{" "}
          © {year} EdisonValley All rights reserved
        </p>
      </footer>
    </div>
  );
}

export default ReactCourse;

const dashboardApi = `BaseUrl = "http://api.certificates.edisonvalley.com/api/v1"

<--- Account --->

👉🏻 Login ==>

    api :  "/account/login/"
    method : "post"
    data : {
      username:"",
      password:""
    }

   
👉🏻 Profile ==>
    
    api :  "/account/profile/"
    method : "get"


👉🏻 Logout ==>
    
    api :  "/account/logout"
    method : "post"
    data : {
      token:""
    }
    
    
👉🏻 Logout ==>
    
    api :  "/account/logout/"
    method : "post"
    data : {
      token:""
    }
    
    
<--- Course  ---> 

👉🏻 All Courses ==>
    
    api :  "/course/course/"
    method : "get"
    
    
👉🏻 Create A Course ==>
    
    api :  "/course/course/"
    method : "post"
    data : {
      course_name : "",  (type : string)
      duration : "", (type : number)
      course_category : "", (type : string, required)
    }
    
    
👉🏻 Single Course Details ==>
    
    api :  "/course/course/{courseId}"
    method : "get"
    
    
👉🏻 Update Course Details ==>
    
    api :  "/course/course/{courseId}"
    method : "put"
    data : {
      course_name : "",  (type : string)
      duration : "", (type : number)
      course_category : "", (type : string, required)
    }
    
    
👉🏻 Delete a Course ==>
    
    api :  "/course/course/{courseId}"
    method : "delete"
    
    
👉🏻 All Courses Category ==>
    
    api :  "/course/course_category/"
    method : "get"
    
    
👉🏻 Create a Courses Category ==>
    
    api :  "/course/course_category/"
    method : "post"
    data:{
      course_category_name : "" (type : string,),
      designation : "" (type : string)
    }
    
    
👉🏻 Single Courses Category Details ==>
    
    api :  "/course/course_category/{courseCategoryId}"
    method : "get"
 
    
👉🏻 Update Courses Category Details ==>
    
    api :  "/course/course_category/{courseCategoryId}"
    method : "put"
        data:{
      course_category_name : "" (type : string,),
      designation : "" (type : string)
    }


👉🏻 Delete a Courses Category Details ==>
    
    api :  "/course/course_category/{courseCategoryId}"
    method : "delete"
    
 
 <--- student --->
 
 👉🏻 All students ==>
    
    api :  "/student/student/"
    method : "get"
    
    
👉🏻 Create a students ==>
    
    api :  "/student/student/"
    method : "post"
    data : {
      email : "" (type : email, maxLength : 60, ),
      phone : "" (type : number, maxLength: 10, minLength: 10 ),
      full_name : "" (type : string, required ),
      address : "" (type : string),
      dob : "" (type : date),
      start_date : "" (type : date),
      end_date : "" (type : date),
      designation : "" (type : string)
    }
    
    
👉🏻 Single Student Details ==>
    
    api :  "/student/student/{studentId}"
    method : "get"
    
    
👉🏻 Update a students ==>
    
    api :  "/student/student/{studentId}"
    method : "put"
    data : {
      email : "" (type : email, maxLength : 60, ),
      phone : "" (type : number, maxLength: 10, minLength: 10 ),
      full_name : "" (type : string, required ),
      address : "" (type : string),
      dob : "" (type : date),
      start_date : "" (type : date),
      end_date : "" (type : date),
      designation : "" (type : string)
    }
    
    
👉🏻 Delete a students ==>
    
    api :  "/student/student/{studentId}"
    method : "delete"
    
    
 <--- student course --->
 
👉🏻 All student course  ==>
    
    api :  "/student/student_course/"
    method : "get"
    
 
👉🏻 Create a student course  ==>
    
    api :  "/student/student_course/"
    method : "post"
    data:{
      student : "" (type : string, required)
      course : "" (type : string, required)
      progress : "" (type : string)
    }
    
    
👉🏻 Single Student Course ==>
    
    api :  "/student/student_course/{studentCourseId}"
    method : "get"
    
    
👉🏻 Updare Student Course ==>
    
    api :  "/student/student_course/{studentCourseId}"
    method : "put"
    data : {
      student : "" (type : string, required)
      course : "" (type : string, required)
      progress : "" (type : string)
    }
    
    
    
👉🏻 Delete Student Course ==>
    
    api :  "/student/student_course/{studentCourseId}"
    method : "delete"
   `;
const gitCommand = `1. git init

2. git remote set-url origin <https://name-of-the-repository-link>

3. git remote add origin https://github.com/user/repo.git

4. git remote -v

5. To add a single file: git add <file>
   To add everything at once: git add .
   
6. git commit -m "commit message"

7. git push

8. git pull

9. Git revert

10. Git merge


11. git clone <https://name-of-the-repository-link>


12. Viewing branches:   git branch --list
    Creating a new branch: git branch <branch-name>
    Deleting a branch: git branch -d <branch-name>

13. git checkout <name-of-your-branch>

14. git status   


////////
1.  The git init command creates a new Git repository. It can be used to convert an existing, unversioned project to a Git repository or initialize a new, empty repository
    
    eg:- git init
      
  
2. Change current repository to new one
   
   eg:- git remote set-url origin <https://name-of-the-repository-link>
   
   
3. Set a new remote repository
    
   eg:- git remote add origin https://github.com/user/repo.git
   
   
4. Get Current Git repository details

  eg:- git remote -v
   
   
5. Git add

   We need to use the git add command to include the changes of a file(s) into our next commit. 
   
   eg:- 
   
   To add a single file: git add <file>
   
   To add everything at once: git add .


6. Git commit

   Git commit is like setting a checkpoint in the development process which you can go back to later if needed.

   We also need to write a short message to explain what we have developed or changed in the source code.
   
   eg:- git commit -m "commit message"


7. Git push

   
   After committing your changes, the next thing you want to do is send your changes to the remote server. Git push uploads your commits to the remote repository.
   
   eg:- git push <remote> <branch-name>
   
   if your branch is newly created : git push -u origin <branch_name>
   
   
8. Git pull

   This command is a combination of git fetch and git merge which means that, when we use git pull, it gets the updates from remote repository (git fetch) and immediately applies the latest changes in your local (git merge).
   
   eg:- git pull <remote>
   
   
9. Git revert

   undo the last commit 
   
   A safer way that we can undo our commits is by using git revert. To see our commit history, first we need to use git log -- oneline:
   
   eg:- git revert commitId
   
   
10. Git merge

    Merge branches in git
    
    For example, when you want to merge your feature branch into the dev :-
    
    First you should switch to the dev branch: git checkout dev
    
    Before merging, you should update your local dev branch: git pull
    
    Finally, you can merge your feature branch into dev: git merge <branch-name>
    
11. Git clone
   
   Git clone basically makes an identical copy of the latest version of a project in a repository and saves it to your computer.
   
   eg:- git clone <https://name-of-the-repository-link>
    

12. Git branch

   By using branches, several developers are able to work in parallel on the same project simultaneously. We can use the git branch command for creating, listing and deleting branches.
   
   eg:-
   
   Viewing branches:   git branch --list
   
   Creating a new branch: git branch <branch-name>
   
   Deleting a branch: git branch -d <branch-name>
   

 13. Git checkout
 
    We use git checkout mostly for switching from one branch to another.
    
    eg:- git checkout <name-of-your-branch>
    
    create and switch to a branch at the same time: git checkout -b <name-of-your-branch>
    
    
14. Git status  
    
   The Git status command gives us all the necessary information about the current branch. 
   
   eg:- git status`;
